import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getAnalytics, isSupported } from 'firebase/analytics';
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from 'firebase/app-check';

const getAuthDomain = () => {
  if (typeof window === 'undefined') return import.meta.env.VITE_FIREBASE_AUTH_DOMAIN;
  const hostname = window.location.hostname;
  // First-party auth domain trick only applies to our real production domain(s),
  // to avoid Safari/iOS third-party cookie issues. Everything else (localhost,
  // staging, PR preview channels, etc.) uses the default Firebase authDomain,
  // which is a registered Authorized domain with a working /__/auth/handler.
  const FIRST_PARTY_AUTH_DOMAINS = ['choreography.studio', 'www.choreography.studio'];
  const isFirstPartyProdDomain = FIRST_PARTY_AUTH_DOMAINS.includes(hostname);
  return isFirstPartyProdDomain ? hostname : import.meta.env.VITE_FIREBASE_AUTH_DOMAIN;
};

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: getAuthDomain(),
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

// Enable App Check debug token in development
if (import.meta.env.DEV) {
  (window as any).FIREBASE_APPCHECK_DEBUG_TOKEN = true;
}

// Initialize App Check
if (typeof window !== 'undefined') {
  const siteKey = import.meta.env.VITE_RECAPTCHA_SITE_KEY;
  if (siteKey) {
    initializeAppCheck(app, {
      provider: new ReCaptchaEnterpriseProvider(siteKey),
      isTokenAutoRefreshEnabled: true,
    });
    console.log('Firebase App Check initialized with reCAPTCHA Enterprise.');
  } else {
    console.warn('VITE_RECAPTCHA_SITE_KEY is missing. Firebase App Check initialization skipped.');
  }
}


// Initialize Analytics conditionally (handles environments like SSR/Cypress/AdBlockers)
export let analytics: any = null;
isSupported().then((supported) => {
  if (supported) {
    analytics = getAnalytics(app);
    console.log('Firebase Analytics initialized successfully.');
  }
});
